// Recovered compiled webpack factory 94416. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { M: () => s });
  var n = i(12115);
  function s(t) {
    let e = (0, n.useRef)(null);
    return (null === e.current && (e.current = t()), e.current);
  }
}
